import { useTranslation } from 'react-i18next'
import { STORAGE_KEYS } from '@/utils/constants'
import { useState, useEffect, useRef } from 'react'
import { useEnumsStore } from '@/stores/enumsStore'
import { RuFlag } from './flags/RuFlag'
import { UsFlag } from './flags/UsFlag'
import '@/styles/language-switcher.css'

export function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  // Нормализуем код языка (берем только первые 2 символа)
  const normalizeLanguage = (lang: string) => {
    return lang.split('-')[0].toLowerCase()
  }

  const currentLanguage = normalizeLanguage(i18n.language || 'ru')
  const languages = [
    { code: 'ru', name: 'Русский', Flag: RuFlag, displayCode: 'RU' },
    { code: 'en', name: 'English', Flag: UsFlag, displayCode: 'EN' },
  ]

  const loadEnums = useEnumsStore((state) => state.loadEnums)

  const handleLanguageChange = (langCode: string) => {
    localStorage.setItem(STORAGE_KEYS.LANGUAGE, langCode)
    setIsOpen(false)
    i18n.changeLanguage(langCode).then(() => {
      // Перезагружаем enum'ы с новой локалью (Accept-Language уже обновится через interceptor)
      loadEnums()
    })
  }

  // Закрытие при клике вне компонента
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const currentLang = languages.find(lang => lang.code === currentLanguage) || languages[0]

  return (
    <div className="language-switcher" ref={dropdownRef}>
      <button
        className="language-switcher-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Switch language"
      >
        <span className="language-flag">
          <currentLang.Flag className="flag-icon" />
        </span>
        <span className="language-code">{currentLang.displayCode}</span>
        <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'}`}></i>
      </button>
      {isOpen && (
        <div className="language-dropdown">
          {languages.map((lang) => {
            const FlagComponent = lang.Flag
            return (
              <button
                key={lang.code}
                className={`language-option ${currentLanguage === lang.code ? 'active' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                <span className="language-flag">
                  <FlagComponent className="flag-icon" />
                </span>
                <span className="language-name">{lang.name}</span>
                {currentLanguage === lang.code && (
                  <i className="fas fa-check"></i>
                )}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
